export default {
  explore: {
    filters: 'Фильтры',
    resetFilters: 'Сбросить фильтры',
    addKeyword: 'Добавить ключевое слово',
  },
  recipe: {
    contributedBy: 'Автор',
    ingredients: 'Ингредиенты',
    directions: 'Способы приготовления',
    fullRecipe: 'Посмотреть полный рецепт на',
    similarDrinks: 'Подобные напитки',
  },
  featuredRecipes: {
    loadMore: 'Загрузить еще',
  },
  recipeFind: {
    filterBy: 'Фильтровать по',
    name: 'Название',
    ingredients: 'Ингредиенты',
    keywords: 'Ключевые слова',
    searchForIngredients: 'Вы можете искать несколько ингредиентов, разделяя их пробелом',
    searchForKeywords: 'Вы можете искать несколько ключевых слов, разделяя их пробелом',
  },
  recipeList: {
    viewRecipe: 'Просмотреть рецепт',
  },
  recipeToolbar: {
    print: 'Распечатать',
    share: 'Поделиться',
    shareOnFacebook: 'Поделиться через Facebook',
    shareOnTwitter: 'Поделиться через Twitter',
    copyURL: 'скопировать URL',
    hideImage: 'Скрыть изображение',
  },
  favorites: {
    removeAllFavorites: 'Удалить все избранное',
    noFavoriteDrinks: 'У тебя нет любимых напитков',
    removeFavoritesPrompt: 'Вы уверены, что хотите удалить все избранное',
    delete: 'Удалить',
    cancel: 'Отмена',
  },
  keywordList: {
    enterYourKeyword: 'Введите ключевое слово',
  },
  search: {
    findYourDrink: 'Найдите свой напиток',
  },
  pageNotFound: {
    pageNotFound: 'Страница, которую вы ищете, не найдена',
    backToHome: 'Вернуться домой',
  },
};
